import { NegotiationBoundary } from '@procureai/schemas';
import { isNotEmpty, isNotNil } from 'ramda';

import { NegotiationBoundaryListItem } from '../NegotiationBoundaryListItem/NegotiationBoundaryListItem';

interface NegotiationBoundaryListItemProps {
  items?: NegotiationBoundary[] | null;
}

export const NegotiationBoundaryList = ({ items }: NegotiationBoundaryListItemProps) => {
  return (
    <>
      {isNotNil(items) && isNotEmpty(items)
        ? items.map((item, index) => <NegotiationBoundaryListItem key={index} sequence={index} {...item} />)
        : null}
    </>
  );
};
